export default __webpack_public_path__ + "static/media/GogoLogoSquareWhite.54185e3e.png";